import Component from "../../lib/component";

export const NavMenuItemsConfig = {
    componentTypeKey: 'NavMenuItems',
    baseHtmlClass: 'nav_menu__items',
    selector: '.nav_menu__items',
};

export class NavMenuItems extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: NavMenuItemsConfig
        });

        const revealerId = this.element.dataset['nav_menu_revealer_id'];
        this.revealerElement = document.getElementById(revealerId);
        if (this.revealerElement) this.handleRevealer();

        this.items = this.element.querySelectorAll(':scope > .nav_menu__item');
    }

    handleRevealer() {
        this.revealerElement.classList.add('nav_menu__item--revealer');
        if (this.hasHtmlClassState('open')) {
            this.revealerElement.classList.add('nav_menu__item--revealer_open');
            this.revealerElement.classList.remove('nav_menu__item--revealer_closed');
        } else {
            this.revealerElement.classList.add('nav_menu__item--revealer_closed');
            this.revealerElement.classList.remove('nav_menu__item--revealer_open');
        }
        this.revealerElement.addEventListener('click', function () {
            this.toggleHtmlClassState('open');
            this.toggleHtmlClassState('closed');
            this.revealerElement.classList.toggle('nav_menu__item--revealer_open');
            this.revealerElement.classList.toggle('nav_menu__item--revealer_closed');
        }.bind(this));
    };

}